export default [{
  path: '/manage/:site/',
  name: 'manage.home',
  component: () => import('@/views/admin/Index.vue'),
  children: [
    /********************* 系统裁剪拾请保留以下内容 *********************/
    {
      path: 'user/',
      name: 'manage.user',
      meta: {
        name: '成员管理'
      },
      component: () => import('@/views/manage/user/Index.vue')
    },
    /********************* 系统裁剪拾请保留以上内容 *********************/
    {
      path: 'page/base/',
      name: 'manage.page.base',
      meta: {
        name: '基本信息'
      },
      component: () => import('@/views/manage/pages/base/Index.vue')
    },
    {
      path: 'page/official/',
      name: 'manage.page.official',
      meta: {
        name: '官网首页'
      },
      component: () => import('@/views/manage/pages/official/Index.vue')
    },
    {
      path: 'page/carousel/',
      name: 'manage.page.carousel',
      meta: {
        name: '轮播图'
      },
      component: () => import('@/views/manage/pages/carousel/Index.vue')
    },
    {
      path: 'page/mini/',
      name: 'manage.page.mini',
      meta: {
        name: '小程序页面'
      },
      component: () => import('@/views/manage/pages/mini/Index.vue')
    },
    {
      path: 'ceramic/',
      name: 'manage.ceramic',
      meta: {
        name: '瓷器管理'
      },
      component: () => import('@/views/manage/ceramic/Index.vue')
    },
    {
      path: 'panorama/',
      name: 'manage.panorama',
      meta: {
        name: '全景管理'
      },
      component: () => import('@/views/manage/panorama/Index.vue')
    },
    {
      path: 'subscriber/',
      name: 'manage.subscriber',
      meta: {
        name: '粉丝管理'
      },
      component: () => import('@/views/manage/subscriber/Index.vue')
    },
    {
      path: 'client/',
      name: 'manage.client',
      meta: {
        name: '用户管理'
      },
      component: () => import('@/views/manage/client/Index.vue')
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/router/modules/manage.js